/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *|
 *| IBM Cognos Products: Dashboard
 *|
 *| (C) Copyright IBM Corp. 2021, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define(function() {
	'use strict';
	class Rave2comet {
		get config(){
			return {
				'type': 'DriverAnalysis',
				'isRecommendable': false,
				'noDataQuery': true,
				'doesNotSupportSortAction': true,
				'doesNotSupportTopBottomAction': false,
				'doesNotSupportFormatAction': true,
				'doesNotSupportCustomGroupAction': true,
				'useFPDAsInsightsInput' : true,
				'ignoreElementColor': true,
				'doesNotSupportOLAP': true,
				'supportsPossibleKeyDrivers': true,
				'hideAggTypeInAxisLabels': true,
				'doesNotSupportAnnotations': true,
				'enableCustomDataSelection': false,
				'thumbnail': {
					'properties': {
						'valueAxis.line.visible': true,
						'valueAxis.ticks.visible': true
					}
				},
				'propertiesToSetBeforeData': [
					'widget.data.truncate'
				],
				'listenForPropChanges': [
					'widget.legend.size'
				],
				'slots': {
					'values': {
						icon: 'target',
						'actions': [
							'TopKeyDriversAction',
							'PossibleKeyDriverAction'
						],
						'coachMark': {
							'titleResource': 'coachMarkTitleSpiralTarget',
							'contentResource': 'coachMarkContentSpiralTarget',
							'mappedOnly': true,
							'showPopover': true
						}
					}
				},
				'groupedProperty': {
					'widget.legend.color': ['widget.legend.titleColor'],
					'widget.legend.font': ['widget.legend.titleFont']
				},
				'properties':{
					'widget.data.truncate': {
						active: false,
						defaultValue: true
					},
					'format.compact':{
						'active':false
					},
					'legendPosition':{
						'active':false
					},
					'legend.display':{
						'active':false
					},
					'optimizeSize':{
						'defaultValue': true
					},
					'widget.legend.font': {
						active: true
					},
					'widget.legend.size': {
						'active': false
					},
					'widget.legend.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'widget.legend.titleColor': {
						'colorClass': true,
						'active': true
					},
					'valueAxis.title.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'valueAxis.ticks.labels.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					}
				},
				config:{
					'include':[
						'widget.data.truncate',
						'widget.iterator',
						'contrast.axes.color',
						'contrast.text.color',
						'axis.title.visible',
						'axis.indicators.visible',
						'axis.labels.visible',
						'target.title.visible',
						'valueAxis.zeroOrigin',
						'target.title.color',
						'axis.color',
						'axis.label.color',
						'oneWay.color',
						'twoWay.color',
						'combination.color',
						'optimizeSize',
						'target.stroke.color',
						'backgroundColor',
						'widget.legend.backgroundColor',
						'valueAxis.ticks.labels.visible',
						'valueAxis.ticks.visible',
						'widget.legend.color',
						'widget.legend.splitter',
						'widget.legend.font',
						'widget.legend.titleColor',
						'widget.legend.titleFont',
						'widget.legend.size',
						'widget.legend.swatch.symbol.default',
						'valueAxis.ticks.labels.font',
						'valueAxis.ticks.labels.color',
						'valueAxis.title.font',
						'valueAxis.title.color'
					],
					'exclude':[
					]
				},
				'usages':[
					'Advanced'
				],
				'supportsMaintainAxisScale': false
			};
		}
	}
	return Rave2comet;
});
